import type { MapCoordinates } from "@b2bportal/core-types";
import type { Coordinates } from "@b2bportal/ground-api";

export const toGroundCoordinates = (
  coordinates: MapCoordinates
): Coordinates => {
  return {
    lat: coordinates.lat,
    lon: coordinates.lng,
  };
};

export const toMapCoordinates = (coordinates: Coordinates): MapCoordinates => {
  return {
    lat: coordinates.lat,
    lng: coordinates.lon,
  };
};
